import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import { FaWhatsapp } from "react-icons/fa";
import { GoArrowLeft } from "react-icons/go";
import { MdOutlineContentCopy } from "react-icons/md";

const RichTextModal = ({
  open,
  onClose,
  initialValue = "",
  title = "Editor",
  onCopy,
  editorValue,
  setEditorValue,
  handleWhatsAppShare,
}) => {

  useEffect(() => {
    if (open) {
      setEditorValue(initialValue);
    }
  }, [open, initialValue]);

  if (!open) return null;

  return (
    <div className="rtm-overlay">
      <div className="rtm-modal">

        {/* Header */}
        <div className="d-flex justify-content-start align-items-center mb-3">
          <button className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1" onClick={onClose}>
            <GoArrowLeft className="font-size-h4" />
          </button>
          <h5 className="mb-0">{title}</h5>
        </div>

        {/* Editor */}
        <ReactQuill
          theme="snow"
          value={editorValue}
          onChange={setEditorValue}
          modules={{
            toolbar: [
              ["bold", "italic", "underline","link"],
            ],
          }}
        />

        {/* Footer */}
        <div className="d-flex justify-content-between mt-3">
          <button
            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm mr-2"
            onClick={() => {
              if (onCopy) onCopy(editorValue);
            }}
          >
            <MdOutlineContentCopy className="mr-2 font-size-h4" />
            Copy Text
          </button>
          <button
            className={`btn btn-sm px-5 btn-primary`}
            onClick={handleWhatsAppShare}
          >
            <FaWhatsapp  className="mr-2 font-size-h4" />
            Share on WhatsApp
          </button>
        </div>

      </div>
    </div>
  );
};

export default RichTextModal;
